module.exports = __webpack_public_path__ + "static/media/06.7eac9890.jpeg";